<template>
      <div>
            <div class="d-flex flex-row justify-content-center gap-3">
                  <h2 class="text-center mb-8">{{ getTitle }}</h2>
                  <i data-toggle="tooltip" data-placement="bottom" data-html="true"
                     :title="getInfo"
                     class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
            </div>
            <div class="table-responsive">
                  <table class="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                        <thead class="thead-light">
                        <tr class="text-left">
                              <th class="w-25">{{ getTableColName }}</th>
                              <th class="w-25">{{ __('statistics.impressions') }}</th>
                              <th class="w-25">{{ __('statistics.clicks') }}</th>
                              <th class="w-25">{{ __('statistics.ctr') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="singleStatistic in statistics" class="text-left">
                              <td>
                                    <span class="text-gray-800 font-weight-bold text-hover-primary mt-2">
                            <span v-if="article">{{ getSegmentValue(singleStatistic.product) }}</span>
                            <span v-if="brand">{{ getSegmentValue(singleStatistic.brand) }}</span>
                            <span v-if="category">{{ getSegmentValue(singleStatistic.category_l1) }}</span>
                        </span>
                              </td>
                              <td>
                        <span class="text-monospace d-block mt-2">
                            {{ singleStatistic.impressions }}
                        </span>
                              </td>
                              <td>
                        <span class="text-monospace d-block mt-2">
                            {{ singleStatistic.clicks }}
                        </span>
                              </td>
                              <td>
                        <span class="text-monospace d-block mt-2">
                            {{ calculateCtr(singleStatistic.impressions, singleStatistic.clicks)}} %
                        </span>
                              </td>
                        </tr>
                        </tbody>
                  </table>
            </div>
      </div>
</template>

<script>
export default {
      props: {
            statistics: {
                  types: [Object, Array],
            },
            storeName: String,
            article: Boolean,
            brand: Boolean,
            category: Boolean,
      },

      computed: {
            getTitle() {
                  if (this.category) {
                        return this.__('statistics.best_categories_for_store', {storeName: this.storeName});
                  } else if (this.article) {
                        return this.__('statistics.best_products_for_store', {storeName: this.storeName});
                  } else {
                        return this.__('statistics.best_brands_for_store', {storeName: this.storeName});
                  }
            },
            getTableColName() {
                  if (this.category) {
                        return this.__('general.category');
                  } else if (this.article) {
                        return this.__('general.article_name');
                  } else {
                        return this.__('general.brand_name');
                  }
            },
            getInfo() {
                  if (this.category) {
                        return this.__('statistics.info_best_category');
                  } else if (this.article) {
                        return this.__('statistics.info_best_product');
                  } else {
                        return this.__('statistics.info_best_brand');
                  }
            },
      },

      methods: {
            shortName(name) {
                  if (name.length < 42) {
                        return name;
                  }

            return name.substring(0, 42) + '...'
        },
        getSegmentValue(segment) {
            if (segment) {
                return this.shortName(segment)
            } else {
                return this.__('general.unknown')
            }
        },
        calculateCtr(impressions, clicks)  {
            if (impressions === 0) {
                return 0
            }

            return (clicks / impressions).toFixed(2)
        },
    },
}
</script>
